import type { BookmarkType } from "../types";

type PersonaTabsProps = {
  tabs: { key: BookmarkType; label: string }[];
  activeTab: BookmarkType | null;
  onChange: (tab: BookmarkType) => void;
};

const PersonaTabs = ({ tabs, activeTab, onChange }: PersonaTabsProps) => {
  if (tabs.length <= 1) return null;

  return (
    <div role="tablist" className="tw-flex tw-items-center tw-gap-6 tw-border-b tw-border-gray-200">
      {tabs.map((tab) => {
        const isActive = tab.key === activeTab;
        return (
          <button key={tab.key} type="button" role="tab" aria-selected={isActive} onClick={() => !isActive && onChange(tab.key)} className={`-tw-mb-px tw-border-b-2 tw-bg-transparent tw-px-1 tw-pb-2.5 tw-pt-1 tw-text-sm tw-font-medium tw-transition-colors ${isActive ? "tw-border-primary-purple-500 tw-text-primary-purple-600" : "tw-border-transparent tw-text-gray-500 hover:tw-text-gray-700"}`}>
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default PersonaTabs;
